import { Button } from '@mui/material';
import { CheckCircle, Extension } from '@mui/icons-material';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { handleGetExtraResource } from "store/extraResource/thunks";
import CreateExtensionActivites from "./createExtenstionAcitvites";
import { useExtraResourceEbook } from "store/extraResource/selectors";
import * as Sentry from "@sentry/react";
import Loading from "components/Loading";
import BadgeButton from "components/AdminBooks/BadgeButton";
import { message } from "antd";
import SentryWrap from 'components/Sentry';

const ExtraResourceAdmin = ({ pageId, bookId, hasPermission = true }) => {
  const dispatch = useDispatch();
  const [states, setStates] = useState({
    open: false,
    loading: { type: "", value: "" },
  });
  const extraResource = useExtraResourceEbook();

  const filterExtraResource = useMemo(() => {
    if (extraResource) {
      return extraResource?.filter((item) => item?.pageId == pageId) || [];
    } else {
      return [];
    }
  }, [pageId, extraResource]);

  const updateMultipleStates = useCallback(async (updates) => {
    setStates((prevStates) => ({
      ...prevStates,
      ...updates,
    }));
  }, []);

  const fetchContent = async () => {
    try {
      if (states?.value) return;
      if (bookId && pageId) {
        updateMultipleStates({ type: "fetchContent", value: true });
        await dispatch(handleGetExtraResource({ bookId: bookId }));
        updateMultipleStates({ type: "fetchContent", value: false });
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [bookId]);

  const onCloseModal = () => {
    updateMultipleStates({ open: false });
  };

  return (
    <SentryWrap>
      <BadgeButton
        className='extenActivityCstm'
        startIcon={
          states?.value && states?.type === "fetchContent" ? (
            <Loading size={15} white={true} />
          ) : <Extension />
        }
        showBadge={filterExtraResource && filterExtraResource?.length > 0}
        backgroundColor="#9333ea"
        onClick={() => {
          if (!hasPermission) {
            message.warning('You do not have permission to access this feature.');
            return;
          }
          if (states?.value && states?.type === "fetchContent") {
            return;
          }
          updateMultipleStates({ open: true });
        }}
      >
        Extension activities
      </BadgeButton>

      <CreateExtensionActivites
        data={filterExtraResource}
        open={states.open}
        close={onCloseModal}
        bookId={bookId}
        pageId={pageId}
      />
    </SentryWrap>
  );
};

export default ExtraResourceAdmin;
